function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useEffect, useState } from "react";
import { getRemoteModule } from "../globalScriptProviders/remotes";
import { getDigitalOptimizationClientID, flagCache, useLaunchDarklyCache } from "../utils/ld-cache";
import logger, { LapelError } from "../logger";
var LD_MBOX_CONFIG = "ldMboxConfig";
var mergeConfigs = function(defaultConfig, localConfig, additionalConfig) {
    return _extends({}, defaultConfig, localConfig, additionalConfig);
};
function matchesPattern(value, overrides) {
    // Split the string by commas to get the individual patterns
    var patterns = overrides.split(",").map(function(pattern) {
        return pattern.trim();
    });
    for(var _i = 0; _i < patterns.length; _i++){
        var pattern = patterns[_i];
        // Check if the pattern contains a wildcard ('-*')
        if (pattern.endsWith("-*")) {
            // Remove the '-*' part and check if the value starts with the base string
            var base = pattern.slice(0, -2); // Remove the last two characters '-*'
            if (value.startsWith(base)) {
                return true;
            }
        } else {
            // If no wildcard, check for an exact match
            if (value === pattern) {
                return true;
            }
        }
    }
    return false; // No match found
}
function checkDisableFlags(disableMboxes, allowOverrides, modifiedName, overrideList, defaultConfig, localConfig, setConfig) {
    var disableConfig = {
        abTestEndDate: "1/1/2000"
    };
    if (disableMboxes && (!allowOverrides || !matchesPattern(modifiedName, overrideList))) {
        setConfig(mergeConfigs(defaultConfig, localConfig, disableConfig));
        return true;
    }
    // default is false
    return false;
}
var fetchLDConfig = /*#__PURE__*/ _async_to_generator(function(name, flagsByClient) {
    var _flagsByClient_LD_MBOX_CONFIG, mBoxes, getConfigForItem;
    return _ts_generator(this, function(_state) {
        mBoxes = ((_flagsByClient_LD_MBOX_CONFIG = flagsByClient[LD_MBOX_CONFIG]) == null ? void 0 : _flagsByClient_LD_MBOX_CONFIG.mBoxes) || {};
        getConfigForItem = function(item) {
            for(var key in mBoxes){
                if (key.endsWith("*") && item.startsWith(key.slice(0, -1))) {
                    return mBoxes[key];
                }
            }
            return mBoxes[item] || null; // Return the direct match if no wildcard match found
        };
        return [
            2,
            getConfigForItem(name)
        ];
    });
});
var fetchRemoteConfig = /*#__PURE__*/ _async_to_generator(function(name, defaultConfig, localConfig, setConfig) {
    var _instance, _ref, modPromise, modFactory, instance, mboxConfig;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    getRemoteModule({
                        remote: "abtFederationHost",
                        module: "config"
                    })
                ];
            case 1:
                _ref = _state.sent(), modPromise = _ref.module;
                return [
                    4,
                    modPromise
                ];
            case 2:
                modFactory = _state.sent();
                instance = modFactory();
                if (typeof ((_instance = instance) == null ? void 0 : _instance.default) !== "function") {
                    console.error("mbox config corrupted!");
                    return [
                        2
                    ];
                }
                mboxConfig = instance.default("mbox")(name);
                setConfig(mboxConfig ? mergeConfigs(defaultConfig, localConfig, mboxConfig) : null);
                return [
                    2
                ];
        }
    });
});
var handleError = function(err, name) {
    logger.error(new LapelError(err.message + " while loading abt config for " + name, {
        cause: err
    }), {
        tags: {
            functionName: "useAbtConfig"
        },
        fingerprint: [
            "useAbtConfig",
            name
        ]
    });
};
export var useAbtConfig = function(name, localConfig) {
    var _useState = _sliced_to_array(useState(null), 2), config = _useState[0], setConfig = _useState[1];
    var entry = useLaunchDarklyCache(getDigitalOptimizationClientID());
    // mBoxes using wildcards
    var modifiedName = name;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    useEffect(function() {
        var _flagsByClient_LD_MBOX_CONFIG, _flagsByClient_LD_MBOX_CONFIG1, _flagsByClient_LD_MBOX_CONFIG2, _flagsByClient_LD_MBOX_CONFIG3;
        var mounted = true;
        var clientId = getDigitalOptimizationClientID();
        var defaultConfig = {
            disableFoocMask: false
        };
        if (!flagCache[clientId]) {
            setConfig(localConfig);
            return;
        }
        var flagsByClient = flagCache[clientId].flags;
        var disableFederatedConfig = (_flagsByClient_LD_MBOX_CONFIG = flagsByClient[LD_MBOX_CONFIG]) == null ? void 0 : _flagsByClient_LD_MBOX_CONFIG.disableFederatedConfigFile;
        var disableMboxes = (_flagsByClient_LD_MBOX_CONFIG1 = flagsByClient[LD_MBOX_CONFIG]) == null ? void 0 : _flagsByClient_LD_MBOX_CONFIG1.disableMboxes;
        var allowOverrides = (_flagsByClient_LD_MBOX_CONFIG2 = flagsByClient[LD_MBOX_CONFIG]) == null ? void 0 : _flagsByClient_LD_MBOX_CONFIG2.allowOverrides;
        var overrideList = (_flagsByClient_LD_MBOX_CONFIG3 = flagsByClient[LD_MBOX_CONFIG]) == null ? void 0 : _flagsByClient_LD_MBOX_CONFIG3.overrides;
        var fetchConfig = /*#__PURE__*/ _async_to_generator(function() {
            var ldConfig, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!mounted) return [
                            2
                        ];
                        if (localConfig.mapPropsToName !== null && localConfig.mapPropsToName !== undefined) {
                            modifiedName = "" + modifiedName + "-*";
                        }
                        // disable mBoxes and check override list here
                        if (checkDisableFlags(disableMboxes, allowOverrides, modifiedName, overrideList, defaultConfig, localConfig, setConfig)) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetchLDConfig(modifiedName, flagsByClient)
                        ];
                    case 1:
                        ldConfig = _state.sent();
                        if (!ldConfig) return [
                            3,
                            2
                        ];
                        setConfig(mergeConfigs(defaultConfig, localConfig, ldConfig));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        setConfig(mergeConfigs(defaultConfig, localConfig, {}));
                        if (!!disableFederatedConfig) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetchRemoteConfig(name, defaultConfig, localConfig, setConfig)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        handleError(err, name);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        fetchConfig();
        return function() {
            mounted = false;
        };
    }, [
        entry
    ]); // Ensure to add dependencies
    return config;
};

//# sourceMappingURL=useAbtConfig.js.map